export const initialStore = {
  calculatorData: {
    portOperation: [],
    clientQuery: {},
    fleetList: [],
    cargoList: [],
    cargoExtraDetails: [],
    autoSave: false,
  },
  selectedVessels: {},
  syncBunker: false,
  isOverride: true,
  estimationEstId: "",
  splitHireArray: [],
  portDistanceResponse: {},
  realPortDistanceResponse: {},
  portDistancePayloadResponse: {},
};
